var _circle, _circle2, _g, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDigitalDeposit = function SvgDigitalDeposit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#65C1B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Digital_Deposit_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Digital_Deposit_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: -7,
    y: 26.8,
    width: 28.8,
    height: 28.8,
    rx: 1.667,
    stroke: "#000",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 39.8,
    cy: 6.4,
    r: 14.4,
    stroke: "#000",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10 20a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v29a2 2 0 0 1-2 2H12a2 2 0 0 1-2-2V20Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v29a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V18Z",
    fill: "#B2E0DA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 15.496c0-.274.222-.496.496-.496h4.795c.764 0 1.485.35 1.959.949s1.195.948 1.96.948h7.58c.765 0 1.486-.35 1.96-.948A2.498 2.498 0 0 1 31.71 15h4.794c.274 0 .496.222.496.496V51a1 1 0 0 1-1 1H12a1 1 0 0 1-1-1V15.496Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 41.25h16M16 44.25h9.5",
    stroke: "#B2E0DA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 21,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#fff"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 28,
    r: 9,
    fill: "#3EB2A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 33V22.43M19.375 28.375 24 33l4.625-4.625",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDigitalDeposit;